import type { HTMLAttributes } from 'react'

export const PhotosetStepWrapper = (props: HTMLAttributes<HTMLDivElement>) => (
	<div
		className='relative grid h-full grid-rows-[minmax(0,1fr)_auto] overflow-y-hidden bg-neutral-50'
		{...props}
	/>
)

export const PhotosetStepBodyContainer = ({
	$disabled,
	className,
	...props
}: HTMLAttributes<HTMLDivElement> & { $disabled?: boolean }) => (
	<div
		className={`w-full overflow-y-scroll px-6 transition-opacity duration-500 ease-in-out ${
			$disabled ? 'pointer-events-none overflow-hidden opacity-40' : ''
		} ${className ?? ''}`}
		{...props}
	/>
)

export const PhotosetStepGridContainer = (
	props: HTMLAttributes<HTMLDivElement>
) => (
	<div
		className='grid w-full grid-cols-[minmax(0,1fr)_auto_auto] grid-rows-[minmax(0,1fr)] px-6'
		{...props}
	/>
)

export const PhotosetStepCardsContainer = (
	props: HTMLAttributes<HTMLDivElement>
) => (
	<div
		className='grid w-full grid-cols-2 items-center gap-6 px-6'
		{...props}
	/>
)
